import styled from "styled-components";

export const GamblingSessionLimitsBox = styled.div`
    font-size: 1.275rem;
    line-height: 1.7rem;
    padding: 15px;
    @media ${({theme}) => theme.mediaQuery.sAndAbove} {
      max-width: 600px;
    }
`